export default __webpack_public_path__ + "static/leadership-en-ebf9cd62824bf12130467260bb9a9194.webp";